import dayjs from "dayjs";
import { pluralizeIfNecessary } from "./pluralize-if-necessary";
import { roundAndDropTrailingZeros } from "./roundAndDropTrailingZeros";


const TIME_UNITS = [{
  milliseconds: 1000,
  name: 'second',
}, {
  milliseconds: 1000 * 60,
  name: 'minute',
}, {
  milliseconds: 1000 * 60 * 60,
  name: 'hour',
}, {
  milliseconds: 1000 * 60 * 60 * 24,
  name: 'day',
}, {
  milliseconds: 1000 * 60 * 60 * 24 * 7,
  name: 'week',
}, {
  milliseconds: 1000 * 60 * 60 * 24 * 30,
  name: 'month',
}, {
  milliseconds: 1000 * 60 * 60 * 24 * 365,
  name: 'year',
}] as const;

type DayJsDate = Parameters<typeof dayjs>[0];

export function calculateTimeLeft(targetDate: DayJsDate) {
  const currentDate = dayjs();
  const timeDifference = dayjs(targetDate).diff(currentDate);
  
  if (timeDifference <= 0) {
    return {
      value: 0,
      unit: TIME_UNITS[0].name,
    };
  }

  if (timeDifference <= TIME_UNITS[0].milliseconds) {
    return {
      value: 1,
      unit: TIME_UNITS[0].name,
    }
  }


  if (timeDifference < TIME_UNITS[1].milliseconds) {
    const value = roundAndDropTrailingZeros(timeDifference / TIME_UNITS[0].milliseconds);
    const unit = pluralizeIfNecessary(TIME_UNITS[0].name, value);
    return {
      value, unit
    };
  }

  if (timeDifference < TIME_UNITS[2].milliseconds) {
    const value = roundAndDropTrailingZeros(timeDifference / (TIME_UNITS[1].milliseconds));
    const unit = pluralizeIfNecessary(TIME_UNITS[1].name, value);
    return {
      value, unit
    };
  }

  if (timeDifference < TIME_UNITS[3].milliseconds) {
    const value = roundAndDropTrailingZeros(timeDifference / (TIME_UNITS[2].milliseconds));
    const unit = pluralizeIfNecessary(TIME_UNITS[2].name, value);
    return {
      value, unit
    };
  }

  if (timeDifference < TIME_UNITS[4].milliseconds) {
    const value = roundAndDropTrailingZeros(timeDifference / (TIME_UNITS[3].milliseconds));
    const unit = pluralizeIfNecessary(TIME_UNITS[3].name, value);
    return {
      value, unit
    };
  }

  if (timeDifference < TIME_UNITS[5].milliseconds) {
    const value = roundAndDropTrailingZeros(timeDifference / (TIME_UNITS[4].milliseconds));
    const unit = pluralizeIfNecessary(TIME_UNITS[4].name, value);
    return {
      value, unit
    };
  }

  if (timeDifference < TIME_UNITS[6].milliseconds) {
    const value = roundAndDropTrailingZeros(timeDifference / (TIME_UNITS[5].milliseconds));
    const unit = pluralizeIfNecessary(TIME_UNITS[5].name, value);
    return {
      value, unit
    };
  }

  const value = roundAndDropTrailingZeros(timeDifference / (TIME_UNITS[6].milliseconds));
  const unit = pluralizeIfNecessary(TIME_UNITS[6].name, value);
  return {
    value, unit
  };
}

export function calculateTimeLeftAndGenerateString(targetDate: DayJsDate) {
  const timeLeft = calculateTimeLeft(targetDate);
  return `${timeLeft.value} ${timeLeft.unit}`;
}